import { render, staticRenderFns } from "./SolicitudInviable.vue?vue&type=template&id=4385e472&scoped=true"
import script from "./SolicitudInviable.vue?vue&type=script&lang=js"
export * from "./SolicitudInviable.vue?vue&type=script&lang=js"
import style0 from "./SolicitudInviable.vue?vue&type=style&index=0&id=4385e472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4385e472",
  null
  
)

export default component.exports